import React from "react";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { ButtonLoading } from "go-form";
import { RenderImage } from "go-app/components/ImageRenderer/ListImageName";
import FormatDate from "go-core/components/Formatters/FormatDate";
import { ReactComponent as LockSVG } from "../../../../../../../../../images/svg/liveOrders/lock.svg";
import { CategoryApi, ItemApi } from "../../../../../../../../../services/Api/Organization/types";

interface Props {
	item: ItemApi | CategoryApi;
	index: number;
	loadingIndex: number;
	handleChangeSuspension: (item: ItemApi | CategoryApi, index: number) => Promise<void>;
	handleEditItem: (item: ItemApi | CategoryApi) => void;
}

const LiveOrdersBlockedItemsTableRowModal = ({
	item,
	index,
	loadingIndex,
	handleEditItem,
	handleChangeSuspension,
}: Props) => {
	const { t } = useTranslation();

	const drawBlockingInformation = () => {
		if (item.suspended) {
			return (
				<span className={`text-danger ${"category" in item ? "ms-2" : "ms-0"} text-break`}>
					<LockSVG style={{ marginBottom: "3px" }} />
					{item?.suspension?.until && (
						<span className="ms-1">
							{`${t("lib:common.word.to")} ${FormatDate(item.suspension.until)}`}
						</span>
					)}
					{item?.suspension?.reason && item.suspension.reason !== "-" && (
						<span className="text-break">{`${item?.suspension?.until ? ", " : " "}${
							item.suspension.reason
						}`}</span>
					)}
				</span>
			);
		}
	};

	const getImage = () => {
		if ("item_group" in item) {
			return item.item_group?.image_link;
		}

		return item.image_link;
	};

	const renderBoxWithBlockingInformation = () => {
		if ("category" in item) {
			return (
				<div className="d-flex flex-wrap">
					<span className="text-muted text-break">{item.category.name}</span>
					{drawBlockingInformation()}
				</div>
			);
		}

		if (item.suspended) {
			return <div className="d-flex flex-wrap">{drawBlockingInformation()}</div>;
		}
	};

	return (
		<tr>
			<td>
				<div className="d-flex align-items-center">
					<RenderImage showColor imageLink={getImage()} data={item} />
					<div className="d-flex flex-column">
						<div className="d-flex">
							<h5
								className={`mb-0 name text-break ${item.suspended ? "text-danger" : ""}`}
								title={item.name}
							>
								{item.name}
							</h5>
						</div>
						{renderBoxWithBlockingInformation()}
						{item.suspension?.order_types && item.suspension.order_types.length > 0 && (
							<div className="d-flex">
								<span>
									{`${t("lib:common.word.type")}:`}
									<span className="text-muted ms-1">
										{item.suspension.order_types
											.map((type) => t(`enums.orders.types.${type}`))
											.join(", ")}
									</span>
								</span>
							</div>
						)}
						{item.suspension?.sources && item.suspension.sources.length > 0 && (
							<div className="d-flex">
								<span>
									{`${t("modules.live_order.field.sources.title")}:`}
									<span className="text-muted ms-1">
										{item.suspension.sources
											.map((source) => t(`enums.orders.source.${source}`))
											.join(", ")}
									</span>
								</span>
							</div>
						)}
					</div>
				</div>
			</td>
			<td className="action">
				<div>
					{item.suspended && (
						<Button variant="light" className="me-2" onClick={() => handleEditItem(item)}>
							{t("lib:common.action.edit")}
						</Button>
					)}
					<ButtonLoading
						loading={index === loadingIndex}
						variant={item.suspended ? "success" : "danger"}
						onClick={() => handleChangeSuspension(item, index)}
					>
						{item.suspended
							? t("modules.live_order.action.unblock.title")
							: t("modules.live_order.action.block.title")}
					</ButtonLoading>
				</div>
			</td>
		</tr>
	);
};

export default LiveOrdersBlockedItemsTableRowModal;
